import React, { useCallback, useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { PC_CONSOLE_DEFAULT_FILTER_CONFIG } from "@/pages/dashboard/components/NewFilter/_config";
import { useSelector } from 'umi';
import { InputItemType, filterValueType } from '../../components/NewFilter/_type';
import { commonDateDefault } from '../../utils/dateUtils';
import { firstWordUpper } from './_utils';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// daily筛选器继承逻辑
const IngameRevenueFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, openSticky = false, path, isHaveFilterSave, children, timeZone = 0 } = props;
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新

  const seasonInfo = useSelector((state: any) =>
    // 初始可能为undefied,在此加兜底
    state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] }
  );
  // 设置inputList,和后端核对后，此次筛选器的展示都是由后端控制，配置为时间，地区，平台和语言四个筛选器
  const [inputList] = useState([
    // {
    //   type: 'rangeDaily',
    //   key: 'rangeTime',
    //   default: getDateDefault({ timeType: 'day', timeZone, startNum: 14, endNum: 1 }),
    //   extraShortcut: seasonInfo
    // },
    commonDateDefault(timeZone, seasonInfo),
  ]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value: filterValueType, inputList: Array<InputItemType>, isHaveExtendFIlter: boolean) => {
    filterValueRef.current = value;
    const { rangeTime, ...otherValues } = value || {};
    const { type, value: timeValue } = value.rangeTime || {};
    // todo 锁定状态下如果锁定时间跟默认时间相同，是否需要单独处理，设置diff为false？
    filterInit({
      ...otherValues,
      rangeTime: [
        timeValue?.[0]?.format('YYYY-MM-DD'),
        timeValue?.[1]?.format('YYYY-MM-DD')
      ],
      [FORM_MAP.RANGE_TIME_DIFF]: !isHaveExtendFIlter,
      timeType: firstWordUpper(type),
    });
  }, [filterInit]);

  const onConfirm = useCallback((value: filterValueType) => {
    filterValueRef.current = value;
    const { rangeTime, ...otherValues } = value || {};
    const { type, value: timeValue } = value.rangeTime || {};
    const obj: any = {
      ...otherValues,
      rangeTime: [
        timeValue?.[0]?.format('YYYY-MM-DD'),
        timeValue?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(type),
      [FORM_MAP.RANGE_TIME_DIFF]: false,
    };
    filterConfirm(obj);
    setBtnPointLog(buttonLogConfig, obj);
  }, [filterConfirm]);

  const onReset = useCallback((value: filterValueType) => {
    filterValueRef.current = value;
    const { rangeTime, ...otherValues } = value || {};
    const { type, value: timeValue } = value.rangeTime || {};
    const obj = {
      ...otherValues,
      rangeTime: [
        timeValue?.[0]?.format('YYYY-MM-DD'),
        timeValue?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(type),
      [FORM_MAP.RANGE_TIME_DIFF]: true,
    };
    filterReset(obj);
    setBtnPointLog(buttonLogConfig, obj, true);
  }, [filterReset]);

  return <Filter
    isHaveFilterSave={isHaveFilterSave}
    pageDefaultSelector={PC_CONSOLE_DEFAULT_FILTER_CONFIG}
    openSticky={openSticky}
    path={path}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
  >
    {children}
  </Filter>;
};

export default IngameRevenueFilter;
